<template>
    <div  class="has-background-grey pubBundleContainer">
        <div class="is-pulled-right">
              <div class="delete top10 right20 has-background-grey is-large" @click="closeIt"></div>
        </div>
        <div class="pubBundleHeadband">
         <div>
            <div class="is-size-3 left10 has-text-grey is-inline-block"><img  src="@/assets/img/Miimu logo.png" width="200"/></div><!-- <b>{{tree[0] ? tree[0].listName : ''}}</b> -->
            <div class="has-text-grey is-pulled-right top10 is-size-5 right10 is-hidden-mobile"><b>public bundle</b></div>
         </div>

          <follow v-if="!myBundle && tree[0]" ref="bp" class="is-inline-block left10 is-size-7 followInModal" :inModal="true"></follow>
          <button v-if="tree[0]" class="button xs is-coolGreen is-small  right20 top10 is-pulled-right" @click="toggleContext"><i class="fas fa-pen"></i></button>

          <div>
               <div class="top2">
                  <div class="avatarTiny is-inline-block top2 left10">
                      <img :src="localProfile.avatarImg" />
                  </div>
                  <div class="is-inline-block is-size-7 vTop top6 left3 has-text-white handleInModal">
                      <div class="top5"><b>{{localProfile.handle}}</b></div>
                  </div>

                 <div class="posRelative is-inline-block">
                    <div v-if="bundles[0] && bundles[0].collabId" @click="openMemberMenu($event)" class="top-2 collabLabel handCursor  left10" >
                       <span>©</span>
                    </div>
  
                    <div v-show="showGroup" class="groupDisplayPublic">
                        <div v-for="(item, i) in members" :key="i" class="">
                          <div class="avatarTiny is-inline-block top2 left10">
                            <img :src="item.avatarImg" />
                          </div>
                          <div class="is-inline-block is-size-7 vTop top6 left3 has-text-white handleInModal">
                            <div><b>{{item.handle}}</b></div>
                          </div>
                        </div>
                    </div>
                 </div>
               </div>
          </div>
          
        </div>
        <bundle-public  class="top10"  v-bind:info="tree[0]" v-bind:listIndex="0"  ref="rootBundleContainers"></bundle-public>
    </div>
</template>

<script>
import BundlePublic from './BundlePublic.vue'
import { AZEventBus } from '../components/AZEventBus'
import Follow from '../components/Follow'
export default {
    props: {mCode: String, deep: Number},
    components: {
        BundlePublic, Follow
    },
    data: function(){
        return {
            bundles: [],
            cards: [],
            tree: [],
            treeNoInbox: [],
            fulled: true,
            showContext: true,
            localProfile: {},
            item: {fState: false, fid: null, pubId: null},
            members: [],
            showGroup: false,
            myBundle: true,
            ratings: [],
            ratingsAvg: [],
            componentName: 'modalBundle'
        }
    },
    mounted: function(){
        let self = this
        function w(d){
            az.addRemSpinner(false, 'id', 'spinTarget') // on child bundlePublic component
            self.loadUp(d)
                        
        }
        function n(){
            az.addRemSpinner(false, 'id', 'spinTarget') // on child bundlePublic component

        }

        AZEventBus.$on('closeAllMenus', this.closeAllMenusHandler)

        az.addRemSpinner(true, 'id', 'spinTarget') // on child bundlePublic component
        if(this.$root.app.isAuth)
          this.$root.app.apiClient.get('subs/data/pubbundle/' + this.mCode, {}, w, n)
        
        else
          this.$root.app.apiClient.get('open/confirm/pubbundle/' + this.mCode, {}, w, n)
    },

    beforeDestroy: function(){
      var self = this;
      AZEventBus.$off('closeAllMenus', this.closeAllMenusHandler)
    },

    methods: {

          closeAllMenusHandler: function(msg){
            this.showGroup = false   
          },

          openMemberMenu: function(e){
            e.stopPropagation() 
            if(!this.showGroup) 
                this.showGroup = true; 
            else 
                this.showGroup = false
          },
          toggleFulled: function(){
            this.fulled = !this.fulled
          },
          toggleContext: function(){
            this.showContext = !this.showContext
          },
          loadUp: function(data){


              var self = this

              
            

              self.ratings = data.ratings || [];
              self.ratingsAvg = data.ratingsAvg || [];

              let localCards = data.cards
              this.localProfile =  data.profile

              this.members =  data.members.filter(e => {
                return e.handle != self.localProfile.handle
              })

              this.item.fState = data.profile.active
              this.item.fid = data.profile.fid
              this.item.pubId = data.profile.pubId

              for(var l = 0; l < data.bundles.length; l++){
                data.bundles[l].items = [];

                if(data.bundles[l].children){
                  data.bundles[l].children = data.bundles[l].children.split(',')
                } else {
                  data.bundles[l].children = []
                }

                data.bundles[l].branch = [data.bundles[l].id]

              /*   if(data.bundles[l].isRoot){
                  data.bundles[l].itemsLoaded = true
                } */
              }

              this.bundles = data.bundles
              this.cards = data.cards

              if(self.bundles[0].id_cog != self.$root.app.userAttrs.sub)
                self.myBundle = false

                  

              for(var i = 0; i < self.cards.length; i++){

                    var ind;
                    var parents = JSON.parse(self.cards[i].parents) || []
                    self.cards[i].parents = JSON.parse(self.cards[i].parents)
                    self.cards[i].tags = JSON.parse(self.cards[i].tags) || []

                    if(self.$root.app.userAttrs.sub != self.cards[i].id_cog){
                      self.cards[i].myCard = false
                    } else {
                      self.cards[i].myCard = true
                    }
                    
                    for(var x = 0; x < parents.length; x++){

                      ind = self.bundles.findIndex(e => {
                          return e.id == parents[x].id
                      })

                      if(ind != -1){
                          self.bundles[ind].items.push({id: self.cards[i].id, p: parents[x].p, cardsIndex: i, entryId: parents[x].entryId, id_cog: self.cards[i].id_cog})
                      }
                        
                    }

                    //ratings

                    let cd = self.cards[i];
                    let myRatings = []
                    for(var l=0; l < self.ratings.length; l++){
                      if(self.ratings[l].id_CARDS == cd.id){
                        myRatings.push({collabId: self.ratings[l].id_COLLAB, rating:  self.ratings[l].rating})
                      }
                    }

                    let avgRatings = []
                    for(l=0; l < self.ratingsAvg.length; l++){
                      if(self.ratingsAvg[l].id_CARDS == cd.id){
                        avgRatings.push({collabId: self.ratingsAvg[l].id_COLLAB, rating:  self.ratingsAvg[l].rating})
                      }
                    }

                    cd.myRatings = myRatings;
                    cd.avgRatings = avgRatings;

              }    
              
              for(var n=0; n < self.bundles.length; n++){
              
                if(self.bundles[n].items){
                  self.bundles[n].items.sort(function(a,b){ return a.p - b.p})
                } 
              }

              self.bundles.forEach(e => {
                if(e.isAlias){
                  let tgtB = self.bundles.find(b => {
                    return b.id == e.aliasTgtId
                  })
                   e.children = tgtB.children;
                   e.listName = tgtB.listName;
                   e.items = tgtB.items;
                   e.collabId = tgtB.collabId
                   e.pubNote = tgtB.pubNote ? tgtB.pubNote : ''
                   tgtB.hideIt = true
                }
              })
  
              self.tree = self.buildTree(self.bundles);
              
              self.tree.sort(function(a,b){ return a.p - b.p})
              
              self.treeNoInbox = self.tree

           
              if(self.deep){
                self.openBundle(self.deep, self.treeNoInbox)
              }

              self.loaded = true;
              /* if(reload){
                self.fullLoad = true
              }  */
              
              //states

             
        },
        buildTree: function(o){
            
            var self = this; 
            var hasDirtyBundles = false


            var allBids = []
            self.bundles.forEach(x => {
              allBids.push(x.id)
            })

            function getChildren(ids, branch, collabId){
                var ret = []
                
                for(var i=0; i < ids.length; i++){

                    //if id is not in bundles array, continue
                    if(!allBids.includes(parseInt(ids[i]))){
                      continue
                    } 

                    var newBranch = branch.concat([ids[i]])

                    ret.push(o.find(function(e){
                        if(e.id == ids[i]){

                        e.branch = newBranch
                        e.processed = true
                        e.parentCollabId = collabId

                        if(e.dirt > 0){
                            hasDirtyBundles = true
                        }
                        
                        if(e.children.length > 0){
                            e.children = getChildren(e.children, newBranch, collabId)
                        }
                            return true
                        }
                        
                    }))
                    }
                    return ret
            }

            var arr = []

            for(var i=0; i < o.length; i++){

                var e = o[i];

                if(e.hideIt){
                    continue
                }

                if(e.hasOwnProperty('processed') || e.isRoot == false) continue

                hasDirtyBundles = false

                

                if(e.children.length > 0){
                    e.children = getChildren(o[i].children, [o[i].id], e.collabId || null);
                } else {

                }


                e.branch = [e.id]
                e.processed = true

                if(hasDirtyBundles || e.dirt > 0){
                    e.hasDirtyBundles = true
                } else {
                    e.hasDirtyBundles = false
                }

                if(e.collabId){
                    e.parentCollabId = e.collabId
                } else {
                    e.parentCollabId = null
                }

                
                
                arr.push(e);


            }
        
        return arr
      },
      closeAllMenus: function(){
        AZEventBus.$emit('closeAllMenus', null)
      },
      closeIt: function(){
          var temp = this.$route.path
          var n
          if(temp.split('/b/').length > 0){
              n = temp.split('/b/')[0]
          }

          history.replaceState(
            {},
            null,
            n 
          )
          this.$emit('close')
      },

      openBundle: function(id, data){
          
            var self = this;
            var b
            function rec(id, arr){
      
                arr.forEach(e => {
                    if(e.id == id){
                        b = e
                        return
                    }

                    if(e.children.length){
                        rec(id, e.children)
                    }
                })
                   
            }
            rec(id, data)


            if(b){
                setTimeout(function(){
                  self.$refs.rootBundleContainers.data = b;
                }, 10)
                
            } else {
                this.$root.app.showModalOK({message: 'The bundle you clicked on no longer exists.'})
            }
        },

      
    }
    
}
</script>